import React from "react";
import classNames from "classnames";
import { ContentMediaPath } from "../utils/ContentMediaPath";
import ImgLazyLoad from "./ImgLazyLoad";

interface BlockingPopupProps {
  isActive: boolean;
  deActivatePopup: () => void;
  popupBlockerCtaUrl: string;
  popupBlockerCtaName: string;
  popupBlockerCtaTarget: string;
  popupBlockerTitle: string;
  popupBlockerContent: string;
  popupBlockerDisclaimer: string;
  popupBlockerBackgroundImageDesktop: string;
  popupBlockerBackgroundImageMobile: string;
  allowUserToClosePopupBlocker: boolean;
}

interface BlockingPopupState {
  matches: boolean;
}

function decodeHtmlEntities(str) {
  const textarea = document.createElement("textarea");
  textarea.innerHTML = str;
  return textarea.value;
}

class BlockingPopup extends React.Component<
  BlockingPopupProps,
  BlockingPopupState
> {
  constructor(props: BlockingPopupProps) {
    super(props);
    this.state = { matches: window.matchMedia("(min-width: 768px)").matches };
  }
  componentDidMount(): void {
    const mediaQuery = window.matchMedia("(min-width: 768px)");
    mediaQuery.addListener((e) => {
      this.setState({ matches: e.matches });
    });
  }

  render() {
    const activeState = classNames({
      "blocking-popup": true,
      active: this.props.isActive,
      inactive: !this.props.isActive,
    });
    return (
      <div className={activeState}>
        <div className="popup_sign_up_main_wrapper">
          <div
            className="popup_overlay"
            onClick={
              this.props.allowUserToClosePopupBlocker &&
              this.props.deActivatePopup
            }
          ></div>
          <div className="popup_sign_up_wrapper">
            <div
              className="popup-container"
              style={{
                background: `url(${
                  this.state.matches
                    ? this.props.popupBlockerBackgroundImageDesktop
                    : this.props.popupBlockerBackgroundImageMobile
                })`,
                backgroundSize: "cover",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center center",
                borderRadius: "4px 4px 0",
              }}
            >
              {this.props.allowUserToClosePopupBlocker && (
                <div
                  className="popup_close"
                  onClick={
                    this.props.allowUserToClosePopupBlocker &&
                    this.props.deActivatePopup
                  }
                >
                  <ImgLazyLoad
                    src={`${ContentMediaPath}images/close-popup-icon.png`}
                    alt="Close Pop Up"
                  />
                </div>
              )}
              <div className="popup_disclaimer">
                {this.props.popupBlockerDisclaimer}
              </div>
            </div>
            <div className="popup_content">
              <div
                className="title"
                dangerouslySetInnerHTML={{
                  __html: decodeHtmlEntities(
                    this.props.popupBlockerTitle || ""
                  ),
                }}
              />
              <div
                className="content"
                dangerouslySetInnerHTML={{
                  __html: decodeHtmlEntities(
                    this.props.popupBlockerContent || ""
                  ),
                }}
              />
            </div>
            <div className="popup_space">
              {!!this.props.popupBlockerCtaUrl &&
                !!this.props.popupBlockerCtaName && (
                  <div className="button_space">
                    <a
                      href={this.props.popupBlockerCtaUrl}
                      className="btn btn--primary fixed_width"
                    >
                      {this.props.popupBlockerCtaName}
                    </a>
                  </div>
                )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default BlockingPopup;
